// extracted by mini-css-extract-plugin
export var container = "_redotech-redo-web-src-labeled-input-container";
export var description = "_redotech-redo-web-src-labeled-input-description";
export var error = "_redotech-redo-web-src-labeled-input-error";
export var horizontal = "_redotech-redo-web-src-labeled-input-horizontal";
export var label = "_redotech-redo-web-src-labeled-input-label";
export var light = "_redotech-redo-web-src-labeled-input-light";
export var thin = "_redotech-redo-web-src-labeled-input-thin";
export var vertical = "_redotech-redo-web-src-labeled-input-vertical";